import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Shield } from 'lucide-react'
import { auth } from '../lib/supabase'

export function ResetPasswordPage() {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault()
    if (password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match')
      return
    }

    setIsLoading(true)
    setError(null)

    const { error: updateError } = await auth.updateUser({ password })
    if (updateError) {
      setError(updateError.message)
      setIsLoading(false)
      return
    }

    setSuccess(true)
    setIsLoading(false)
    setTimeout(() => navigate('/login', { replace: true }), 2000)
  }

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_#f6fbff,_#e9eff6_52%,_#e3ebf3)] px-4 py-8">
      <div className="mx-auto max-w-md">
        <div className="app-surface overflow-hidden">
          <div className="border-b border-slate-200 bg-white px-6 py-4">
            <div className="flex items-center gap-2">
              <div className="rounded-lg bg-[var(--brand-primary)] p-1.5 text-white">
                <Shield size={16} />
              </div>
              <span className="font-brand text-xl font-bold text-[var(--brand-deep)]">ASC Survey</span>
            </div>
            <p className="mt-2 text-sm font-semibold text-slate-600">Set Your New Password</p>
          </div>

          {success ? (
            <div className="px-6 py-8 text-center">
              <p className="text-sm font-semibold text-emerald-700">Password updated successfully. Redirecting to login...</p>
            </div>
          ) : (
            <form onSubmit={handleReset} className="space-y-4 px-6 py-5">
              <div>
                <label htmlFor="new-password" className="block text-xs font-bold uppercase tracking-wider text-slate-500">
                  New Password
                </label>
                <input
                  id="new-password"
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-1 block w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm focus:border-[var(--brand-primary)] focus:outline-none focus:ring-2 focus:ring-blue-100"
                />
              </div>
              <div>
                <label htmlFor="confirm-password" className="block text-xs font-bold uppercase tracking-wider text-slate-500">
                  Confirm Password
                </label>
                <input
                  id="confirm-password"
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="mt-1 block w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm focus:border-[var(--brand-primary)] focus:outline-none focus:ring-2 focus:ring-blue-100"
                />
              </div>
              {error && <p className="text-sm text-red-600">{error}</p>}
              <button type="submit" disabled={isLoading} className="btn-primary w-full py-2.5 text-sm disabled:opacity-60">
                {isLoading ? 'Updating...' : 'Set Password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}
